export default __webpack_public_path__ + "static/media/dacha.14b38320.svg";